<template>
  <div class="notDataBox" style="color: #666">
    <!-- 暂无数据! -->
    <img src="../../assets/img/notData.png" v-if="type == 'nodata'" />
    <img src="../../assets/img/No_search.png" v-if="type == 'nosearch'" />
    <p class="no_data_font">暂无数据</p>
  </div>
</template>
<script>
export default {
  props: ['type']
};
</script>
<style scoped>
.notDataBox {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.no_data_font {
  color: #666;
  font-size: 16px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/noData/index.vue